<template>
  <el-dialog
    title="手动推送报备至明源"
    v-model="dialogVisible"
    width="900px"
    draggable
    :close-on-click-modal="false"
    :destroy-on-close="true"
    @closed="$emit('close')"
  >
    <el-row :gutter="20">
      <el-col :span="12">
        <h4>源报备数据</h4>
        <!-- <el-divider>源报备数据</el-divider> -->
        <el-card :shadow="false">
            <el-descriptions :column="1">
          <el-descriptions-item label="报备次数">{{
            item.manyTimes
          }}</el-descriptions-item>
          <el-descriptions-item label="系统编号">
            <el-checkbox
              :label="item.id"
              size="large"
              v-if="isCanCheck"
            ></el-checkbox>
            <span v-else>{{ item.id }}</span>
          </el-descriptions-item>
          <el-descriptions-item label="报备单号">{{
            item.hNumber
          }}</el-descriptions-item>
          <el-descriptions-item label="公司名称">{{
            item.company
          }}</el-descriptions-item>
          <el-descriptions-item label="带看人"
            >{{ item.daikanName }}/{{ item.daikanMobile }}</el-descriptions-item
          >
          <el-descriptions-item label="报备人"
            >{{ item.consumerName }}/{{
              item.consumerMobile
            }}</el-descriptions-item
          >
          <el-descriptions-item label="客户姓名">{{
            item.clientName
          }}</el-descriptions-item>
          <el-descriptions-item label="客户性别">{{
            item.sex
          }}</el-descriptions-item>
          <el-descriptions-item label="客户号码">{{
            item.clientMobile
          }}</el-descriptions-item>
          <el-descriptions-item label="带看项目">{{
            item.estateName
          }}</el-descriptions-item>
          <el-descriptions-item label="到案人数">{{
            item.dueNum
          }}</el-descriptions-item>
          <el-descriptions-item label="到案时间">{{
            item.dueTime
          }}</el-descriptions-item>
          <el-descriptions-item label="报备备注">{{
            item.comment
          }}</el-descriptions-item>
          <el-descriptions-item label="报备时间">{{
            item.creationTime
          }}</el-descriptions-item>
        </el-descriptions>
        </el-card>
      </el-col>
      <el-col :span="12">
        <h4>推送内容如下</h4>
       <el-card :shadow="false">
        <!-- <el-divider>推送内容如下</el-divider> -->
        <el-form
          :model="form"
          ref="form"
          :rules="rules"
          label-width="100px"
          v-loading="loading"
        >
          <el-form-item label="公司名称">
            {{ item.daikanCompany }}
          </el-form-item>
          <el-form-item label="带看业务员">
            {{ item.daikanName }}({{ item.daikanMobile }})
          </el-form-item>

          <el-form-item label="客户号码">
            {{ item.clientMobileConverted }}
          </el-form-item>
          <el-form-item label="客户性别">
            {{ item.sex }}
          </el-form-item>
          <el-form-item label="项目名称">
            {{ item.estateName }}
          </el-form-item>
          <el-form-item label="到案人数"> {{ item.dueNum }}人 </el-form-item>
          <el-form-item label="到案时间">
            {{ item.dueTime }}
          </el-form-item>
          <el-form-item label="备注">
            <el-input
              v-model="form.yunkePushRemark"
              type="textarea"
              placeholder=""
            ></el-input>
            <div class="help-block">推送至明源系统的备注信息，可修改</div>
          </el-form-item>
          <el-form-item> </el-form-item>
        </el-form>
       </el-card>
      </el-col>
    </el-row>

    <template #footer>
      <el-button
        type="primary"
        @click="onSubmit"
        :loading="saving"
        :disabled="loading"
        >立即推送</el-button
      >
    </template>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialogVisible: false,
      loading: false,
      saving: false,
      item: {},
      form: {},
      rules: {
        // yunkeExterType: [
        //   { required: true, message: "请选择直连系统类型", trigger: "change" },
        // ],
        // yunkeYkResidentTel: [
        //   {
        //     required: true,
        //     message: "请输入开发商报备手机号码",
        //     trigger: "blur",
        //   },
        // ],
        // yunkeExterResidentType: [
        //   { required: true, message: "请选择驻场类型", trigger: "change" },
        // ],
      },
    };
  },
  props: ["id"],
  emits: ["success", "close"],
  watch: {
    id: {
      handler() {
        if (this.id) {
          this.loadDtl();
          this.dialogVisible = true;
          // this.title = "修改";
        }
      },
      immediate: true,
    },
  },
  created() {},
  methods: {
    /**
     * 加载详情
     */
    loadDtl() {
      this.loading = true;
      this.$http
        .get("admin/v1/report/dtl?id=" + this.id)
        .then((res) => {
          if (res.code == 0) {
            this.item = res.data;
            this.form = {
              id: this.id,
              yunkePushRemark: res.data.yunkePushRemark,
            };
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    /**
     *
     */
    onSubmit() {
        if (
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.saving = true;
            this.$http
              .post("admin/v1/reportNew/pushyunke", this.form)
              .then((res) => {
                if (res.code == 0) {
                  this.$message.success(res.msg);
                  this.$emit("success");
                  this.dialogVisible = false;
                } else {
                  this.$message.danger(res.msg);
                }
              })
              .finally(() => (this.saving = false));
          }
        })
      );
    },
  },
};
</script>

<style scoped></style>
